module.exports = __webpack_public_path__ + "static/rust_monster-040e0fffab16ff3128901646784ab80f.jpeg";